import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey:
    process.env.REACT_APP_FIREBASE_API_KEY ||
    "AIzaSyC6wm3CimyPRBBPXf0jqyZIkiVWOiA2REE",
  authDomain:
    process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ||
    "maskan-8b7c7.firebaseapp.com",
  projectId:
    process.env.REACT_APP_FIREBASE_PROJECT_ID || "maskan-8b7c7",
  storageBucket:
    process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ||
    "maskan-8b7c7.appspot.com",
  messagingSenderId:
    process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "428974404333",
  appId:
    process.env.REACT_APP_FIREBASE_APP_ID ||
    "1:428974404333:web:0042fc87624e9e603092e4",
  measurementId:
    process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-H79T3RSVGD",
};

const app = initializeApp(firebaseConfig);
export default app;
